




























































































































import { RootState } from '@/store/store';
import { FHIRDownloadSettings } from '@/store/modules/fhir/types/fhir.types';
import { UpdateDownloadSettingsPayload } from '@/api/fhir.api';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

interface FormFormat {
  formatTypeId: number;
  formatType: string;
  isEnabled: boolean;
}

@Component
export default class DownloadSettingsTab extends Vue {
  public formFormats: FormFormat[] = [];
  public formMaxDocMode: 'set-limit' | 'unlimited' = 'set-limit';
  public formLimitValue = 1;

  private savedFormats: FormFormat[] = [];
  private savedMaxDocMode: 'set-limit' | 'unlimited' = 'set-limit';
  private savedLimitValue = 1;
  private initialized = false;

  @Action('fhir/getDefaultDownloadPermissions')
  getDefaultDownloadPermissions!: () => void;

  @Action('fhir/updateDownloadSettings')
  updateDownloadSettings!: (payload: UpdateDownloadSettingsPayload) => void;

  @State(({ fhir }: RootState) => fhir.downloadSettings)
  downloadSettings!: FHIRDownloadSettings | undefined;

  @State(({ fhir }: RootState) => fhir.apiState.updateDownloadSettings.loading)
  isSaving!: boolean;

  public mounted() {
    this.getDefaultDownloadPermissions();
  }

  @Watch('downloadSettings', { immediate: true })
  onDataLoaded(settings: FHIRDownloadSettings | undefined) {
    if (!settings) return;
    this.initFormFromSettings(settings);
  }

  private initFormFromSettings(settings: FHIRDownloadSettings) {
    this.formFormats = settings.formats.map((f) => ({
      formatTypeId: f.formatTypeId,
      formatType: f.formatType,
      isEnabled: f.isEnabled
    }));

    this.formMaxDocMode = settings.isUnlimited ? 'unlimited' : 'set-limit';
    this.formLimitValue = settings.downloadLimit ?? 1;

    this.saveSnapshot();
    this.initialized = true;
  }

  private saveSnapshot() {
    this.savedFormats = this.formFormats.map((f) => ({ ...f }));
    this.savedMaxDocMode = this.formMaxDocMode;
    this.savedLimitValue = this.formLimitValue;
  }

  get noFormatsSelected(): boolean {
    return this.formFormats.every((f) => !f.isEnabled);
  }

  get isDirty(): boolean {
    if (!this.initialized) return false;
    if (this.formMaxDocMode !== this.savedMaxDocMode) return true;
    if (
      this.formMaxDocMode === 'set-limit' &&
      this.formLimitValue !== this.savedLimitValue
    )
      return true;
    return this.formFormats.some(
      (f, i) => f.isEnabled !== this.savedFormats[i]?.isEnabled
    );
  }

  public handleCancel() {
    this.formFormats = this.savedFormats.map((f) => ({ ...f }));
    this.formMaxDocMode = this.savedMaxDocMode;
    this.formLimitValue = this.savedLimitValue;
  }

  public async handleSave() {
    await this.updateDownloadSettings({
      formats: this.formFormats.map((f) => ({
        formatTypeId: f.formatTypeId,
        isEnabled: f.isEnabled
      })),
      isUnlimited: this.formMaxDocMode === 'unlimited',
      downloadLimit:
        this.formMaxDocMode === 'set-limit' ? this.formLimitValue : undefined
    });
    this.saveSnapshot();
  }
}
